import HttpService from "../../core/services/HttpService";
import HttpCallConfig from "../../core/models/HttpCallConfig";
import Asset from "../../subscription/models/Asset";

export const getAsset = async (assetId: string, httpConfig: HttpCallConfig | undefined = undefined): Promise<Asset> => {
  const response = await HttpService.Instance.get(`${process.env.REACT_APP_API_URL}assets/${assetId}`, httpConfig);
  return response.json();
}


// WEBPACK FOOTER //
// ./src/modules/shared/services/AssetApi.ts